export function timeGuard<T>(
	task: () => Promise<T>,
	returnValueOnTimeout: T | (() => T),
	timeout: number,
): Promise<T> {
	return Promise.race<T>([
		task(),
		new Promise((resolve) =>
			setTimeout(() => {
				resolve(
					typeof returnValueOnTimeout === 'function'
						? (returnValueOnTimeout as () => T)()
						: returnValueOnTimeout,
				);
			}, timeout),
		),
	]);
}
